import * as Yup from 'yup'

import flow from 'lodash/flow'

import float from '@galo-monitor/forms/validators/float.validator'
import number from '@galo-monitor/forms/validators/number.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const machineSchema = ({ t, data }) => {
  const potentialMotor = data?.is_motorized
    ? flow(
      number({ t }),
      required({ t })
    )(Yup.string())
    : number({ t })(Yup.string())

  return Yup.object().shape({
    name: required({ t })(Yup.string()),
    machine_type_id: required({ t })(Yup.string()),
    maker_name: required({ t })(Yup.string()),
    model_name: required({ t })(Yup.string()),
    is_motorized: Yup.boolean().nullable(),
    potential_motor: potentialMotor,
    year_fabrication: Yup.string(),
    price: float({ t })(Yup.string())
  })
}

export default machineSchema
